import { HeaderAlertService } from '@uxdf/direct-shared-lib';
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { BindAgentError } from '../actions/loyalty/actions-agent';
import { Store } from '@ngrx/store';
import { State } from '../reducers';

@Injectable({
  providedIn: 'root'
})
export class LoyaltyAlertService {
  constructor(private readonly alert: HeaderAlertService, private readonly store: Store<State>) {}

  public alertRequestLoyaltySuccess() {
    this.alert.clean();
    const message = $localize`:@@loyalty-alert-service.loyaltyInnerPageRequestSentSuccess:Your request has been sent`;
    this.alert.add({ type: 'success', content: message });
  }

  public alertRequestLoyaltyError(httpError: any) {
    this.alert.clean();
    const message = 'Loyalty error: ' + httpError.status + '. ' + httpError.error.message;
    this.alert.add({ type: 'error', content: message });
  }

  public catchAgentError(error: any) {
    this.store.dispatch(new BindAgentError(error));
    this.alert.clean();
    if (error instanceof HttpErrorResponse) {
      this.alert.add({ type: 'error', content: 'Amadeus+Me: ' + error.status + '. ' + error.error.message });
    } else {
      const errorMessage = $localize`:@@loyalty-alert-service.loyaltyRegistrationRequestError:
      Oops, we could not enroll you with Amadeus+Me, because some information is missing in your profile.
      Please go to My profile to add missing information.`;
      this.alert.add({ type: 'error', content: errorMessage, translate: true });
    }
  }
}
